module.exports = __webpack_public_path__ + "static/media/Snipe.6cef2ff4.png";